import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";
import {
    dateClassRule,
    dateFormatter,
    timeFormatter,
    dateValueGetter,
    timeValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";

export default () => [
    {
        pages: [paths.feedback],
        config: {
            headerName: getLocalizedString("feedbackCode"),
            field: 'publicationCode',
            filter: "agSetColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.feedback],
        config: {
            headerName: getLocalizedString("whoSends"),
            field: 'ownerName',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.feedback],
        config: {
            headerName: getLocalizedString("whoReceives"),
            field: 'receiverName',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.feedback],
        config: {
            headerName: getLocalizedString("status"),
            field: 'status',
            filter: "agSetColumnFilter",
            cellRenderer: "FeedbackStatus",
        }
    },
    {
        pages: [paths.feedback],
        config: {
            headerName: getLocalizedString("date"),
            field: 'date',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.feedback],
        config: {
            headerName: getLocalizedString("time"),
            field: 'time',
            filter: "agTextColumnFilter",
            cellClass: "timeType",
            valueFormatter: timeFormatter,
            valueGetter: timeValueGetter,
        }
    },
    {
        pages: [paths.feedback],
        config: {
            headerName: getLocalizedString("reference"),
            field: 'reference',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.feedback],
        config: {
            headerName: getLocalizedString("text"),
            field: 'text',
            cellRenderer: "RichTextRenderer",
        }
    },
    {
        pages: [paths.feedback],
        config: {
            headerName: getLocalizedString("comments"),
            field: 'comments',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.feedback],
        config: {
            headerName: getLocalizedString("revisionDate"),
            field: 'revisionDate',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.feedback],
        config: {
            headerName: getLocalizedString("purpose"),
            field: 'type',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.feedback],
        config: {
            headerName: getLocalizedString("modality"),
            field: 'mode',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.feedback],
        config: {
            headerName: getLocalizedString("year"),
            field: 'year',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.feedback],
        config: {
            headerName: getLocalizedString("period"),
            field: 'period',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.feedback],
        config: {
            headerName: getLocalizedString("image"),
            field: 'image',
            filter: "agTextColumnFilter",
            cellRenderer: "ImageRenderer",
        }
    },
    {
        pages: [paths.feedback],
        config: {
            headerName: getLocalizedString("evidence"),
            field: 'file',
            filter: "agTextColumnFilter",
            cellRenderer: "FileRenderer",
        }
    },
    {
        pages: [paths.feedback],
        config: {
            headerName: getLocalizedString("scope"),
            field: 'privacy',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.feedback],
        config: {
            headerName: getLocalizedString("group"),
            field: 'group',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.feedback],
        config: {
            headerName: getLocalizedString("task"),
            field: 'task',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.feedback],
        config: {
            headerName: getLocalizedString("commentsAreAllowed"),
            field: 'allowsComments',
            filter: "agSetColumnFilter",
        }
    },

    {
        pages: [paths.feedback],
        config: {
            headerName: getLocalizedString("likes"),
            field: 'likes',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.feedback],
        config: {
            headerName: getLocalizedString("role"),
            field: 'role',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.feedback],
        config: {
            headerName: getLocalizedString("whoSendsCode"),
            field: 'ownerCode',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.feedback],
        config: {
            headerName: getLocalizedString("whoReceivesCode"),
            field: 'receiverCode',
            filter: "agTextColumnFilter",
        }
    },
]